// @ts-nocheck
import React from 'react';
import { regulationApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
export default ({
  filter = {},
  ...selectProps
}) => <AutocompleteSelect fetch={async params => {
  return await regulationApi.fetch({
    ...filter,
    ...params
  });
}} refetchParams={{
  filter
}} fetchSingle={regulationApi.get} notFoundText="Регламенты не найдены" placeholder="Выберите регламент" renderOption={(regulation, Option) => <Option key={regulation.id} value={regulation.id} regulation={regulation}>
        {`Регламент № ${regulation.id}`}
      </Option>} {...selectProps} />;
